export const GetYearsRange = (yearsBehind: number, yearsAhead: number) => {
    const now = new Date();
    const year10YearsAgo = now.getFullYear() - yearsBehind;
    const nextYear = now.getFullYear() + yearsAhead;
    const rangeOfYears = Array.from({length: nextYear - year10YearsAgo}, (_, i) => year10YearsAgo + i);
    return rangeOfYears;
} 